export enum MediaGroupType {
    ALBUM = 'album',
    GALLERY = 'gallery'
}
